<dx-popup dragEnabled="true" resizeEnabled="true" [width]="popupWidth" height="auto" maxHeight="800px"
    [showTitle]="true" [(title)]="popUpMessage" [hideOnOutsideClick]="true" [(visible)]="isPopupVisible"
    (onHiding)="refreshFocusedSelection()" (cssClass)="popupContainerStyle" (titleBarOrange)="changeTopBarColor($event)"
    (hidePopUp)="refreshFocusedSelection()" useNative="false" showScrollbar="always"
    (disablePopUpWindow)="setPopUpVisibilityFromChild($event)">
    <div>
        <app-error-feedback-component (feedbackResponse)="errorFeedbackTitle($event)"
            *ngIf="isErrorFeedbackPopupVisible"></app-error-feedback-component>
        <div *ngIf="showLogPopUp" (disablePopUpWindow)="setPopUpVisibilityFromChild($event)">
            <div>
                <h3 [innerHTML]="logFeedbackResponse" *ngIf="!dxGridVisible"></h3>
                <dx-data-grid *ngIf="dxGridVisible" [dataSource]="logRequest.logDetails" [columnAutoWidth]="true"
                    [rowAlternationEnabled]="true" [wordWrapEnabled]="true" height="600px" width="auto"
                    useNative="false" showScrollbar="always" class="gt-data-grid-style" [hoverStateEnabled]="true">
                    <dxo-search-panel [visible]="true" [width]="250" i18n-placeholder="@search ..."
                        placeholder="Search ...">
                    </dxo-search-panel>
                    <dxo-scrolling mode="standard"></dxo-scrolling>
                    <dxi-column width="20%" height="10px" dataField="editedDate" [allowSearch]="true"
                        showScrollbar="always" dataType="date" i18n-caption="@@timeEdited" caption="Time Edited"
                        format="hh:mm" [allowSorting]="true" sortOrder="desc" sortIndex="1"></dxi-column>
                    <dxi-column width="20%" height="10px" dataField="editedDate" [allowSearch]="true"
                        showScrollbar="always" dataType="date" i18n-caption="@@dateEdited" caption="Date Edited"
                        format="dd.MM.yyyy" [allowSorting]="true" sortOrder="desc"></dxi-column>
                    <dxi-column width="70%" height="10px" dataField="logDetail" [allowSearch]="true"
                        showScrollbar="always" sortIndex="0" i18n-caption="@@logDetail"
                        caption="Log Detail"></dxi-column>
                    <dxi-column width="20%" height="10px" dataField="editedBy" [allowSearch]="true"
                        showScrollbar="always" sortIndex="0" i18n-caption="@@editedBy" caption="Edited By"></dxi-column>
                </dx-data-grid>
                <dx-button class="bottom-green-centre" i18n-text="@@closeCaps" text="CLOSE"
                    (onClick)="closeLog()"></dx-button>
            </div>
        </div>
    </div>
</dx-popup>